import React from 'react'
import { AutoComplete, Spin } from 'antd'
import _ from 'lodash'

export function CustomAutoComplete ({ fetchOptions, debounceTimeout = 500, createOptions, ...props }) {
  const [fetching, setFetching] = React.useState(false)
  const [options, setOptions] = React.useState([])
  const fetchRef = React.useRef(0)
  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1
      const fetchId = fetchRef.current
      setOptions([])
      setFetching(true)
      fetchOptions(value).then((dataOrNewOptions) => {
        if (fetchId !== fetchRef.current) {
          return
        }
        if (createOptions) {
          setOptions(createOptions(dataOrNewOptions))
        } else {
          setOptions(dataOrNewOptions)
        }
        setFetching(false)
      })
    }

    return _.debounce(loadOptions, debounceTimeout)
  }, [fetchOptions, debounceTimeout])
  return (
    <AutoComplete
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size='small' /> : <span>No data</span>}
      style={{ width: '100%' }}
      {...props}
      options={options}
    />
  )
}
